import React, { useState } from 'react';
import { Card, Input, Button } from '../../components/ui';
import { AlertTriangle, TrendingUp, Users } from 'lucide-react';
import { cn } from '../../lib/utils';

export function VolunteerHoursLogTool() {
  const [attendees, setAttendees] = useState('1000');
  const [volunteersPer100, setVolunteersPer100] = useState('5');
  const [eventDuration, setEventDuration] = useState('8');
  const [shiftDuration, setShiftDuration] = useState('4');

  const att = parseInt(attendees) || 0;
  const vPer100 = parseFloat(volunteersPer100) || 0;
  const evHr = parseFloat(eventDuration) || 0;
  const shHr = parseFloat(shiftDuration) || 1;

  const activeVolunteersNeeded = Math.ceil((att / 100) * vPer100);
  const totalVolunteerHours = activeVolunteersNeeded * evHr;
  const totalShiftsNeeded = Math.ceil(totalVolunteerHours / shHr);

  return (
    <div className="grid lg:grid-cols-2 gap-8 text-left">
      <div className="space-y-6">
        <Card className="p-6 space-y-4">
          <h3 className="text-lg font-bold">Event Parameters</h3>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-[10px] uppercase font-bold text-gray-400">Target Attendees</label>
              <Input type="number" value={attendees} onChange={e => setAttendees(e.target.value)} />
            </div>
            <div>
              <label className="text-[10px] uppercase font-bold text-gray-400">Vols / 100 Attendees</label>
              <Input type="number" value={volunteersPer100} onChange={e => setVolunteersPer100(e.target.value)} />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-[10px] uppercase font-bold text-gray-400">Event Duration (Hrs)</label>
              <Input type="number" value={eventDuration} onChange={e => setEventDuration(e.target.value)} />
            </div>
            <div>
              <label className="text-[10px] uppercase font-bold text-gray-400">Shift Length (Hrs)</label>
              <Input type="number" value={shiftDuration} onChange={e => setShiftDuration(e.target.value)} />
            </div>
          </div>
        </Card>
      </div>

      <div className="space-y-6">
        <Card className="p-6 bg-teal-50 border-teal-100 flex flex-col justify-center dark:bg-teal-900/20 dark:border-teal-800 h-full">
            <span className="text-[10px] uppercase font-bold text-teal-600 block mb-2 tracking-widest">Total Shifts Needed</span>
            <p className="text-6xl font-black text-teal-700 font-mono mb-4">{totalShiftsNeeded}</p>
            <div className="border-t border-teal-200/50 pt-4 dark:border-teal-800/50">
              <span className="text-xs font-bold text-teal-700/80 block">Active concurrent volunteers: {activeVolunteersNeeded}</span>
              <span className="text-xs text-teal-700/80 block mt-1">Total volunteer hours: {totalVolunteerHours}</span>
            </div>
        </Card>
      </div>
    </div>
  );
}

